// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"51080217","316":"9210e52e","339":"56013c5e","368":"3cfa3325","488":"9ab3554e","538":"feb8f3d3","687":"41df8c53"}[chunkId] + ".chunk.js";
};